import React, { Component } from 'react';

import {
  Collapse,
  ListGroup,
  ListGroupItem
} from 'reactstrap';

class FooterMobileAccordion extends Component {
  constructor(props) {
    super(props);
    this.state = { collapse: false };
  }

  toggle = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    let chevron;
    if (this.state.collapse) {
      chevron = <span className="eir-icon icon-arrowup--black float-right" />;
    } else {
      chevron = <span className="eir-icon icon-arrowdown--black float-right" />;
    }
    return (
      <div className="meganav-mobile">
        <div onClick={this.toggle}        
           tabIndex="0"
           onKeyDown={(e) => {
           if (e.key === 'Enter' || e.key === ' ') {
          this.toggle();
          }
          }}
 className={(this.props.title === undefined) ? "d-none" : "pt-3 pb-3"}>
          {
            (this.props.link != undefined && this.props.link.link.length > 0) ?
              (<a className="first-child-title-link" href={this.props.link.link} title={this.props.link.title} >{this.props.title}</a>)
              :
              (this.props.title)
          }
          {chevron}

        </div>
        <Collapse isOpen={(this.props.title === undefined) ? "false" : this.state.collapse}>
          <ListGroup className="pb-0 meganav-mobile-item mb-2 border-0">
            {this.props.children.map((navItem, index) => {
              return (
                <ListGroupItem key={index} className="meganav-mobile-item pt-4 pb-4 pl-3">
                  <a href={navItem.link.link} dangerouslySetInnerHTML={{ __html: navItem.link.title }}  aria-label={navItem.link.ariaLabel || undefined}/>
                </ListGroupItem>
              );
            })}
          </ListGroup>
        </Collapse>
      </div >
    );
  }
}

export default FooterMobileAccordion;